import { useQuery, useMutation } from '@tanstack/react-query';
import { publicApi } from '@/lib/api';

export const publicShareKeys = {
  all: ['public-share'] as const,
  detail: (shareId: string) => [...publicShareKeys.all, shareId] as const,
};

// Get public share content (no auth required)
export function usePublicShare(shareId: string) {
  return useQuery({
    queryKey: publicShareKeys.detail(shareId),
    queryFn: () => publicApi.getShare(shareId),
    enabled: !!shareId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false, // Don't retry on 404
  });
}

// Verify password for protected share
export function useVerifySharePassword() {
  return useMutation({
    mutationFn: ({ shareId, password }: { shareId: string; password: string }) =>
      publicApi.verifyPassword(shareId, password),
  });
}
